import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchEmailCompanyList } from '../actions/emailReportsActions'

const useFetchingReportCompany = (id) => {
  const dispatch = useDispatch()

  useEffect(() => {
    console.log('here');
    console.log(id);
    dispatch(fetchEmailCompanyList(id))
    
  }, [dispatch])
}

export default useFetchingReportCompany